import { DatePipe } from '@angular/common';
import { Component, Input, SimpleChange, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material';
import { SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import {
  ConfirmDialogModel, currentComponentPageBasedPermissionsSelector$, ConfirmDialogPopupComponent, CrudService, CrudType,
  IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix, PERMISSION_RESTRICTION_ERROR,
  prepareGetRequestHttpParams, prepareRequiredHttpParams, ResponseMessageTypes, RxjsService, SnackbarService, convertTreeToList, PermissionTypes
} from '@app/shared';
import { InspectionCallEscalationDialogComponent } from '@modules/customer/components/customer/technician-installation/inspection-escalation-modal';
import { CustomerVerificationType } from '@modules/customer/shared/enum/customer-verification.enum';
import { CustomerModuleApiSuffixModels, CUSTOMER_COMPONENT } from '@modules/customer/shared/utils/customer-module.enums';
import { EventMgntModuleApiSuffixModels } from '@modules/event-management/shared/enums/configurations.enum';
import { loggedInUserData } from '@modules/others/auth.selectors';
import { UserLogin } from '@modules/others/models/others-module-models';
import { SalesModuleApiSuffixModels } from '@modules/sales/shared/utils/sales-module.enums';
import { TechnicalMgntModuleApiSuffixModels } from '@modules/technical-management/shared/enum.ts/technical.enum';
import { select, Store } from '@ngrx/store';
import { DialogService, DynamicDialogRef } from 'primeng/api';
import { combineLatest } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { CallEscalationDialogComponent } from '../call-escalation-dialog';
import { CreditControlNotificationDialogComponent } from '../credit-control-notification-dialog/credit-control-notification-dialog.component';
import { RadioCallEscalationDialogComponent } from '../radio-call-escalation-dialog';
import { ServiceCallInwarrantyDialogComponent } from '../service-call-inwarranty-dialog/service-call-inwarranty-dialog.component';
import { ServiceCallWaringDialogComponent } from '../service-call-waring-dialog/service-call-waring-dialog.component';
import { SpecialProjectWaringDialogComponent } from '../special-project-waring-dialog/special-project-waring-dialog.component';
import { CallType, ValidateType } from './call-type.enum';
import { PrimeNgTableVariablesModel } from '../../../../../../shared/models/prime-ng-table-list-component-variables.model';
import { BillingModuleApiSuffixModels } from '@modules/sales';

@Component({
  selector: 'app-customer-technical-list',
  templateUrl: './customer-technical-list.component.html',
  styleUrls: ['./customer-technical-list.component.scss'],
  providers: [DynamicDialogRef]
})

export class CustomerTechnicaListComponent extends PrimeNgTableVariablesModel {
  customerId;
  customerAddressId: any;
  partitionId: any
  userData: UserLogin;
  technicallDetail: any;
  showQuickAction: boolean = false;
  selectedServiceIndex: any = 0;
  obNumberList: any;
  selectedRowData: any;
  isLoading: boolean;
  isDetailsView: boolean = false;
  autoIndex: number = 0;
  autoIndexSpecialProject: number = 0;
  serviceValidationsList: any = [];
  specilProjectValidationsList: any = [];
  appointmentId: any;
  isDealerCall: boolean = false;
  isRadio: boolean | string;
  radioRemovalWorkListId: string;
  uniqueCallId;
  rolePermission: any = [];
  overActiveReportWorkListId: string;
  techTableSubscription: any;
  techDetailsSubscription: any;
  techQuerySubscription: any;
  techLoadSubscription: any;
  isFirstTime: boolean = true;
  fromComponent: string;
  actionTabList: any = {
    columns: [
      { field: 'Service', displayName: 'Service Call', isSelected: false, isDisabled: false, order: 1 },
      { field: 'Inspection', displayName: 'Inspection', isSelected: false, isDisabled: false, order: 2 },

      { field: 'Special Project', displayName: 'Special Projects', isSelected: false, isDisabled: false, order: 4 },

    ]
  }

  constructor(
    private crudService: CrudService,
    private sanitizer: DomSanitizer,
    private router: Router, private activatedRoute: ActivatedRoute,
    private rxjsService: RxjsService, private datePipe: DatePipe,
    private store: Store<AppState>,
    public dialogService: DialogService,
    private dialogRef: DynamicDialogRef,
    private dialog: MatDialog,
    private snackbarService: SnackbarService
  ) {
    super();
    this.primengTableConfigProperties = {
      tableCaption: "Customer Technical",
      breadCrumbItems: [{}],
      selectedTabIndex: 0,
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Automated',
            dataKey: 'stagingBayReportId',
            enableBreadCrumb: true,
            enableReset: false,
            enableGlobalSearch: false,
            reorderableColumns: false,
            resizableColumns: false,
            enableScrollable: true,
            checkBox: false,
            enableRowDelete: false,
            enableFieldsSearch: true,
            enableHyperLink: true,
            enableSecondHyperLink: true,
            cursorSecondLinkIndex: 1,
            cursorLinkIndex: 0,
            columns: [{ field: 'callInitiationNumber', header: 'Service Call No', width: "140px" },
            { field: 'customerCallType', header: 'Call Type', width: "100px" },
            { field: 'callInitiationStatus', header: 'Status', width: "110px" },
            { field: 'quotationNumber', header: 'Quote Numbers', width: "140px" },
            { field: 'salesRef', header: 'Seller', width: "160px" },
            { field: 'callCreationDate', header: 'Call Creation Date', width: "160px", isDateTime: true },
            { field: 'scheduledStartDate', header: 'Scheduled', width: "150px", isDateTime: true },
            { field: 'completedDate', header: 'Completed', width: "150px", isDateTime: true },
            { field: 'technicianName', header: 'Technician', width: "140px" },
            { field: 'fault', header: 'Fault', width: "140px" },
            { field: 'flag', header: 'Flag', width: "70px" },
            { field: 'partitions', header: 'Partitions', width: "100px" },
            { field: 'sapStock', header: 'SAP Stock', width: "110px" },
            { field: 'sapRevenue', header: 'SAP Revenue', width: "130px" },
            ],
            shouldShowDeleteActionBtn: false,
            shouldShowCreateActionBtn: false,
            shouldShowFilterActionBtn: true,
            areCheckboxesRequired: false,
            isDateWithTimeRequired: true,
            enableExportCSV: false,
            apiSuffixModel: SalesModuleApiSuffixModels.CALL_INITIATION,
            moduleName: ModulesBasedApiSuffix.TECHNICIAN,
          }
        ]
      }
    }
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      if (!userData) return;
      this.userData = userData;
    });
    this.rxjsService.getUniqueCallId().subscribe((openscapeConfigDetail) => {
      if (openscapeConfigDetail) {
        this.uniqueCallId = openscapeConfigDetail.UniqueCallid;
      }
    });
    this.appointmentId = this.activatedRoute.snapshot.queryParams.appointmentId;
    this.overActiveReportWorkListId = this.activatedRoute.snapshot.queryParams?.overActiveReportWorkListId;

    this.techQuerySubscription = this.activatedRoute.queryParamMap.pipe(distinctUntilChanged()).subscribe((res: any) => {
      this.fromComponent = res?.params?.fromComponent || '';
      if (res && this.activatedRoute.snapshot.queryParams.navigateTab == 3) {
        this.customerId = res?.params?.customerId || '';
        this.customerAddressId = res?.params?.addressId || '';
        this.partitionId = res?.params?.partitionId || '';
        this.isRadio = res?.params?.isRadio || false;
        this.radioRemovalWorkListId = res?.params?.radioRemovalWorkListId || '';
        if (this.isFirstTime) {
          this.getRequiredListData();
        } else {
          this.reset = true;
        }
        this.onResetTechnical();
        if (this.isRadio == 'true') {
          const isExists = this.actionTabList?.columns?.find(el => el?.field == 'Radio Removal');
          if (!isExists) {
            this.actionTabList.columns.push({ field: 'Radio Removal', displayName: 'Radio Removals', isSelected: false, isDisabled: false, order: 5 });
          }
        }
      } else if (res && this.overActiveReportWorkListId || this.fromComponent) {
        this.customerId = res?.params?.customerId || '';
        this.customerAddressId = res?.params?.customerAddressId || '';
        this.partitionId = res?.params?.partitionId || '';

        this.getRequiredListData();
        this.onResetTechnical();
      } else {
        setTimeout(() => {
          this.rxjsService.setGlobalLoaderProperty(false);
        }, 500);
      }
    });
    this.techLoadSubscription = this.rxjsService.getLoadTechnicianProperty().pipe(distinctUntilChanged()).subscribe(isLoad => {
      if (isLoad && (this.activatedRoute.snapshot.queryParams.navigateTab == 3 || this.overActiveReportWorkListId)) {
        this.getRequiredListData();
        this.getTechicalDetatils();
      }
    })

  }

  ngOnInit(): void {
    this.combineLatestNgrxStoreData();
  }

  onActionSubmited(e: any) {
    if (e.data && !e.search && !e?.col?.toString()) {
      this.onCRUDRequested(e.type, e.data);
    } else if (e.data && e.search && !e?.col) {
      this.onCRUDRequested(e.type, e.data, e.search);
    } else if (e.type && !e.data && !e?.col) {
      this.onCRUDRequested(e.type, {});
    } else if (e.type && e.data && e?.col?.toString()) {
      this.onCRUDRequested(e.type, e.data, e?.col);
    }
  }

  onQuickActionClick(e) {
    if (e?.type == 'Inspection') {
      this.checkAllValidationCalls(e?.type);
    } else if (e?.type == 'Dealer') {
      this.checkCreditControllerAlert('Service', true);
    } else {
      this.checkCreditControllerAlert(e?.type);
    }
  }

  getTechicalDetatils() {
    if (!this.customerId || !this.customerAddressId) {
      return
    }
    if (this.techDetailsSubscription && !this.techDetailsSubscription?.closed) {
      this.techDetailsSubscription?.unsubscribe();
      this.rxjsService.setGlobalLoaderProperty(false);
    }
    this.rxjsService.setGlobalLoaderProperty(true);
    this.techDetailsSubscription = this.crudService.get(ModulesBasedApiSuffix.TECHNICIAN, TechnicalMgntModuleApiSuffixModels.CUSTOMER_TECHNICAL_DETAILS, null, null,
      prepareRequiredHttpParams({ customerid: this.customerId, addressid: this.customerAddressId }))
      .subscribe((res: IApplicationResponse) => {
        if (res?.isSuccess) {
          this.technicallDetail = res?.resources;
          if (this.technicallDetail?.isDealerCall) {
            const isExists = this.actionTabList?.columns?.find(el => el?.field == 'Dealer');
            if (!isExists) {
              this.actionTabList.columns.push({ field: 'Dealer', displayName: 'Dealer Call', isSelected: false, isDisabled: false, order: 3 });
            }
          }
        }
        this.onCloseLoader();
      })
  }

  onCloseLoader() {
    setTimeout(() => {
      if (this.techDetailsSubscription?.closed && this.techTableSubscription?.closed) {
        this.rxjsService.setGlobalLoaderProperty(false);
      }
    }, 200);
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData),
      this.store.select(currentComponentPageBasedPermissionsSelector$),]
    ).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      let permission = this.overActiveReportWorkListId ? response[1]["Work List"] : response[1][CUSTOMER_COMPONENT.CUSTOMER]?.find(el => el?.menuName == CUSTOMER_COMPONENT.CUSTOMER_DASHBOARD);
      if (permission) {
        let requestArr = this.overActiveReportWorkListId ? permission?.find(el => el?.menuName == CUSTOMER_COMPONENT.TECHNICAL) : permission?.subMenu?.find(el => el?.menuName == CUSTOMER_COMPONENT.TECHNICAL);
        let techPermission = convertTreeToList([requestArr]);
        this.rolePermission = techPermission;
      }
    });
  }

  getCallType(i: number) {
    if (this.rolePermission) {
      return this.rolePermission?.find(el => el[CUSTOMER_COMPONENT.CALL_TYPE])?.[CUSTOMER_COMPONENT.CALL_TYPE]?.[i];
    }
  }

  getDocumentPermission() {
    if (this.rolePermission) {
      return this.rolePermission?.find(el => el[CUSTOMER_COMPONENT.CALL_TYPE])?.[CUSTOMER_COMPONENT.CALL_TYPE]?.[2]?.subMenu;
    }
  }

  getRequiredListData(pageIndex?: string, pageSize?: string, otherParams?: object) {
    if (!this.customerId || !this.customerAddressId) {
      return
    }
    this.loading = true;
    if (!otherParams) {
      otherParams = {}
      otherParams['CustomerId'] = this.customerId;
      otherParams['AddressId'] = this.customerAddressId;
      if (this.partitionId) {
        otherParams['partitionId'] = this.partitionId;
      }
    }
    let salesModuleApiSuffixModels: SalesModuleApiSuffixModels;
    salesModuleApiSuffixModels = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel;
    console.log(this.fromComponent)
    if (this.fromComponent == "signal-management") {
      salesModuleApiSuffixModels = SalesModuleApiSuffixModels.SIGNAL_CALL_INITIATION
    }
    if (this.techTableSubscription && !this.techTableSubscription?.closed) {
      this.techTableSubscription?.unsubscribe();
      this.rxjsService.setGlobalLoaderProperty(false);
    }
    this.rxjsService.setGlobalLoaderProperty(true);
    this.techTableSubscription = this.crudService.get(
      ModulesBasedApiSuffix.TECHNICIAN,
      salesModuleApiSuffixModels,
      undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).pipe(map((res: IApplicationResponse) => {
      if (res?.resources) {
        res?.resources?.forEach(val => {
          val.requestTypeNameAliceName = val.isDealerCall ? 'Dealer' : val.requestTypeName
          return val;
        })
      }
      return res;
    })).subscribe(data => {
      if (data.isSuccess) {
        this.dataList = data.resources;
        this.totalRecords = data.totalCount;
      } else {
        this.dataList = null;
        this.totalRecords = 0;
      }
      this.reset = false;
      this.loading = false;
      this.isFirstTime = false;
      this.rxjsService.setLoadTechnicianProperty(false);
      this.onCloseLoader();
    })
  }

  technicallInititationDetail;
  onCRUDRequested(type: CrudType | string, row?: object | any, unknownVar?: number | any): void {
    switch (type) {
      case CrudType.CREATE:
        this.openAddEditPage(CrudType.CREATE, row);
        break;
      case CrudType.GET:
        let otherParams = { ...unknownVar };
        otherParams['CustomerId'] = this.customerId;
        otherParams['AddressId'] = this.customerAddressId;
        if (this.partitionId) {
          otherParams['partitionId'] = this.partitionId;
        }
        this.row = row ? row : { pageIndex: 0, pageSize: 10 };
        this.first = row?.pageIndex && row?.pageSize ? row["pageIndex"] * row["pageSize"] : 0;
        this.getRequiredListData(this.row["pageIndex"], this.row["pageSize"], otherParams)
        break;
      case CrudType.VIEW:
        this.openAddEditPage(CrudType.VIEW, row);
        break;
      case CrudType.EDIT:
        if (unknownVar == 'customerCallType') {
          this.selectedRowData = row;
          let SalesModuleApiSuffixModels: SalesModuleApiSuffixModels;
          SalesModuleApiSuffixModels = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel;
          this.isLoading = true;
          this.crudService.get(
            ModulesBasedApiSuffix.TECHNICIAN,
            SalesModuleApiSuffixModels,
            row['callInitiationId'],
            false
          ).subscribe(data => {
            this.loading = false;
            this.rxjsService.setGlobalLoaderProperty(false);
            if (data.isSuccess) {

              this.technicallInititationDetail = data.resources;
              if (data.resources?.notes) {
                const rawNotes = data.resources.notes.replace(/\n/g, ' <br> ');
                const cleanNotes = this.sanitizer.sanitize(SecurityContext.HTML, rawNotes) ?? '';
                this.technicallInititationDetail.notes = this.sanitizer.bypassSecurityTrustHtml(cleanNotes);
              }
            } else {
              this.technicallInititationDetail = null;

            }
            if (this.selectedServiceIndex == 3 || this.selectedServiceIndex == 4) {
              this.onLoadObNumberList();
            }
            this.isLoading = false;
          })
          this.isDetailsView = true;
        }
        break;
      default:
    }
  }

  onResetTechnical() {
    this.isDetailsView = false;
    this.technicallInititationDetail = {};
    this.selectedRowData = {};
    this.obNumberList = [];
    this.selectedServiceIndex = 0;
    this.getTechicalDetatils();
  }

  // ngOnChanges(changes: SimpleChanges){
  //   if(changes.partitionId.currentValue !=""){
  //     this.partitionId = changes.partitionId
  //   }
  // }
  onServiceTabChangeEvent(event) {
    this.selectedServiceIndex = event.index;
    if (this.selectedServiceIndex == 0) {
      this.technicallInititationDetail = '';
      this.crudService.get(
        ModulesBasedApiSuffix.TECHNICIAN, TechnicalMgntModuleApiSuffixModels.CALL_INITIATION,
        this.selectedRowData.callInitiationId,
        false, null).subscribe((data: IApplicationResponse) => {
          this.loading = false;
          this.rxjsService.setGlobalLoaderProperty(false);
          if (data?.isSuccess) {
            this.technicallInititationDetail = data.resources;
            if (data.resources?.notes) {
              const rawNotes = data.resources.notes.replace(/\n/g, ' <br> ');
              const cleanNotes = this.sanitizer.sanitize(SecurityContext.HTML, rawNotes) ?? '';
              this.technicallInititationDetail.notes = this.sanitizer.bypassSecurityTrustHtml(cleanNotes);
            }
          }
        });
    }
  }

  onLoadObNumberList() {
    this.isLoading = true;
    let api = this.crudService.get(ModulesBasedApiSuffix.EVENT_MANAGEMENT,
      EventMgntModuleApiSuffixModels.OCCURANCE_BOOK_SIGNAL_CUSTOMER_ADDRESS,
      undefined, false, prepareGetRequestHttpParams("0", "10", { CustomerId: this.customerId, CustomerAddressId: this.customerAddressId }));
    if (this.selectedServiceIndex == 4) {
      api = this.crudService.get(
        ModulesBasedApiSuffix.TECHNICIAN,
        TechnicalMgntModuleApiSuffixModels.CALL_INITIATION_AUDIT_LOG, null,
        false, prepareGetRequestHttpParams("0", "10", { callInitiationId: this.selectedRowData?.callInitiationId }));
    }
    api.pipe(map((res: IApplicationResponse) => {
      if (res?.resources) {
        res?.resources?.forEach(val => {
          if (this.selectedServiceIndex == 3) {
            val.signalDateTime = this.datePipe.transform(val.signalDateTime, 'medium');
          }
          return val;
        });
      }
      return res;
    })).subscribe((res: IApplicationResponse) => {
      this.obNumberList = res;
      this.isLoading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
    })
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | string, index?: number): void {
    // Get the current query parameters to preserve fromComponent
    const currentQueryParams = this.activatedRoute.snapshot.queryParams;
    
    switch (type) {
      case CrudType.CREATE:
        // this.router.navigate(['/inventory','daily-staging-bay','add-edit'], {});
        break;
      case CrudType.VIEW:
        if (editableObject['isDealerCall']) {
          if (editableObject['requestTypeName'].toLowerCase() == 'inspection') {
            this.router.navigate(['/customer/manage-customers/inspection-call'], { 
              queryParams: { 
                customerInspectionId: editableObject['callInitiationId'], 
                customerId: this.customerId, 
                isDealer: true, 
                isNew: 'customerlist',
                fromComponent: currentQueryParams['fromComponent'] // Preserve the fromComponent parameter
              } 
            });
          } else {
            this.rxjsService.setViewCallInitiationData({
              customerId: this.customerId,
              customerAddressId: this.customerAddressId,
              partitionId: this.partitionId,
              initiationId: editableObject['callInitiationId'],
              technicianName: editableObject['technicianName'],
              appointmentId: editableObject['appointmentId'] ? editableObject['appointmentId'] : null,
              callType: editableObject['requestTypeName'] == CallType.INSTALLATION_CALL ? 1 : (editableObject['requestTypeName'] == CallType.SERVICE_CALL ? 2 : 3), // 2- service call, 1- installation call
              fromComponent: currentQueryParams['fromComponent'] // Preserve the fromComponent parameter
            })
            this.rxjsService.navigateToCallInitiationPage('/customer/manage-customers/dealer-call');
          }
        } else {
          if (editableObject['requestTypeName'].toLowerCase() == 'inspection') {
            this.router.navigate(['/customer/manage-customers/inspection-call'], { 
              queryParams: { 
                customerInspectionId: editableObject['callInitiationId'], 
                customerId: this.customerId, 
                isNew: 'customerlist',
                fromComponent: currentQueryParams['fromComponent'] // Preserve the fromComponent parameter
              } 
            });
          } else if (editableObject['requestTypeName'].toLowerCase() == 'radio removal') {
            this.rxjsService.setViewCallInitiationData({
              customerId: this.customerId,
              customerAddressId: this.customerAddressId,
              partitionId: this.partitionId,
              initiationId: editableObject['callInitiationId'],
              technicianName: editableObject['technicianName'],
              radioRemovalWorkListId: this.radioRemovalWorkListId,
              appointmentId: editableObject['appointmentId'] ? editableObject['appointmentId'] : null,
              callType: 2,
              fromComponent: currentQueryParams['fromComponent'] // Preserve the fromComponent parameter
            })
            this.rxjsService.navigateToCallInitiationPage('/customer/manage-customers/radio-removal-call');
          } else if (editableObject['isUpselling'] || editableObject['isCounterSale']) {
            this.rxjsService.setViewCallInitiationData({
              customerId: this.customerId,
              customerAddressId: this.customerAddressId,
              partitionId: this.partitionId,
              initiationId: editableObject['callInitiationId'],
              callInitiationStatus: editableObject['callInitiationStatus'],
              technicianName: editableObject['technicianName'],
              appointmentId: editableObject['appointmentId'] ? editableObject['appointmentId'] : null,
              isUpselling: editableObject['isUpselling'],
              isCounterSale: editableObject['isCounterSale'],
              callType: editableObject['requestTypeName'] == CallType.INSTALLATION_CALL ? 1 : (editableObject['requestTypeName'] == CallType.SERVICE_CALL ? 2 : 3), // 2- service call, 1- installation call
              fromComponent: currentQueryParams['fromComponent'] // Preserve the fromComponent parameter
            })
            this.rxjsService.navigateToCallInitiationPage();
          } else {
            this.rxjsService.setViewCallInitiationData({
              customerId: this.customerId,
              customerAddressId: this.customerAddressId,
              partitionId: this.partitionId,
              initiationId: editableObject['callInitiationId'],
              callInitiationStatus: editableObject['callInitiationStatus'],
              technicianName: editableObject['technicianName'],
              appointmentId: editableObject['appointmentId'] ? editableObject['appointmentId'] : null,
              callType: editableObject['requestTypeName'] == CallType.INSTALLATION_CALL ? 1 : (editableObject['requestTypeName'] == CallType.SERVICE_CALL ? 2 : 3), // 2- service call, 1- installation call
              fromComponent: currentQueryParams['fromComponent'] // Preserve the fromComponent parameter
            })
            this.rxjsService.navigateToCallInitiationPage();
          }
        }
        break;
    }
  }

  technicalQuickActionOpen() {
    const canCreate = this.rolePermission?.find(el => el[PermissionTypes.ADD]);
    if (!canCreate) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR);
    }
    this.showQuickAction = !this.showQuickAction;
  }

  navigateToInstallationByServiceCall() {
    // Get the current query parameters to preserve fromComponent
    const currentQueryParams = this.activatedRoute.snapshot.queryParams;
    
    if (this.isDealerCall) {
      var routerUrl = '/customer/manage-customers/dealer-call'
    } else {
      var routerUrl = '/customer/manage-customers/call-initiation'
    }
    this.rxjsService.setViewCallInitiationData({
      customerId: this.customerId,
      customerAddressId: this.customerAddressId,
      partitionId: this.partitionId,
      initiationId: "",
      appointmentId: this.appointmentId ? this.appointmentId : null,
      callType: 2, // 2- service call, 1- installation call
      fromComponent: currentQueryParams['fromComponent'] // Preserve the fromComponent parameter
    })
    this.rxjsService.navigateToCallInitiationPage(routerUrl);
  }

  navigateToInstallationBySpecialProject() {
    // Get the current query parameters to preserve fromComponent
    const currentQueryParams = this.activatedRoute.snapshot.queryParams;
    
    if (this.isDealerCall) {
      var routerUrl = '/customer/manage-customers/dealer-call'
    } else {
      var routerUrl = '/customer/manage-customers/call-initiation'
    }
    this.rxjsService.setViewCallInitiationData({
      customerId: this.customerId,
      customerAddressId: this.customerAddressId,
      partitionId: this.partitionId,
      initiationId: "",
      appointmentId: this.appointmentId ? this.appointmentId : null,
      callType: 3, // 3- special project call
      fromComponent: currentQueryParams['fromComponent'] // Preserve the fromComponent parameter
    })
    this.rxjsService.navigateToCallInitiationPage(routerUrl);
  }

  // check credit controller aler
  checkCreditControllerAlert(callType: CallType | any, isDealer?: any) {
    let isAccessDeined = this.getPermissionByActionType(!isDealer ? callType : 'Dealer Call');
    if (isAccessDeined) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR);
    }

    const custVerficationType = isDealer ? CustomerVerificationType.DEALER_CALL : CustomerVerificationType.SERVICE_CALL
    if (callType?.toLowerCase() == 'service') {
      this.onCustomerVerficationCheck(custVerficationType, callType);
    } else {
      this.onAfterCheckCreditControllerAlert(callType);
    }
  }

  onCustomerVerficationCheck(tab, callType) {
    if (this.activatedRoute?.snapshot?.queryParams?.feature_name) {
      this.onAfterCheckCreditControllerAlert(callType);
    } else {
      this.rxjsService.setGlobalLoaderProperty(true);
      let filterObj = { userId: this.loggedInUserData?.userId, customerId: this.customerId, siteAddressId: this.customerAddressId, uniqueCallId: this.uniqueCallId ? this.uniqueCallId : null };
      this.crudService.get(ModulesBasedApiSuffix.CUSTOMER_MANAGEMENT, CustomerModuleApiSuffixModels.CUSTOMER_VERIFICATION_CHECK, null, false,
        prepareRequiredHttpParams(filterObj))
        .subscribe((res: IApplicationResponse) => {
          if (res?.isSuccess && res?.statusCode == 200) {
            this.onAfterCheckCreditControllerAlert(callType);
          } else {
            this.rxjsService.setGlobalLoaderProperty(false);
            
            // Get the current query parameters to preserve fromComponent
            const currentQueryParams = this.activatedRoute.snapshot.queryParams;
            
            var isSignalMgmt = this.router.url?.indexOf('signal-management') != -1;
            this.router.navigate(['/customer/manage-customers/customer-verification'], { 
              queryParams: { 
                customerId: this.customerId, 
                siteAddressId: this.customerAddressId, 
                tab: tab, 
                customerTab: 3, 
                isSignalMgmt: isSignalMgmt, 
                isRadio: this.isRadio, 
                radioRemovalWorkListId: this.radioRemovalWorkListId, 
                overActiveReportWorkListId: this.overActiveReportWorkListId,
                fromComponent: currentQueryParams['fromComponent'] // Preserve the fromComponent parameter
              }, 
              skipLocationChange: true 
            });
          }
        })
    }
  }

  onAfterCheckCreditControllerAlert(callType: CallType) {
    this.rxjsService.setGlobalLoaderProperty(true);
    this.crudService.get(ModulesBasedApiSuffix.BILLING, BillingModuleApiSuffixModels.CREDIT_CONTROLLER_NOTIFICATION_CUSTOMER_OUTSTANDING,
      undefined, false, prepareRequiredHttpParams({ CustomerId: this.customerId, AddressId: this.customerAddressId, createduserId: this.loggedInUserData.userId }))
      .subscribe(response => {
        this.rxjsService.setGlobalLoaderProperty(false);
        if (response.isSuccess) {
          if (response.resources?.outstandingBalance != 0) {
            let data = {
              validateMessage: 'Customer BDI no: ' + response.resources?.bdiNumber + ' has a outstanding balance of R ' + response.resources?.outstandingBalance,
              callType: callType
            }
            this.openCreditControlNotificationDialog(data)
          } else {
            this.checkAllValidationCalls(callType)
          }
        } else {
          this.checkAllValidationCalls(callType)
        }
      })
  }

  // service call
  checkValidateServiceCall() {
    this.rxjsService.setGlobalLoaderProperty(true);
    this.crudService.get(ModulesBasedApiSuffix.TECHNICIAN, TechnicalMgntModuleApiSuffixModels.SERVICE_CALL_INITIATION_VALIDATION,
      undefined, false, prepareGetRequestHttpParams(null, null, {
        CustomerId: this.customerId, AddressId: this.customerAddressId
      })).subscribe(response => {
        this.rxjsService.setGlobalLoaderProperty(false);
        this.isDealerCall = response.resources.isDealerCall
        if (response.resources.isSuccess) {
          this.navigateToInstallationByServiceCall()
        } else {
          if (response.resources.validations.length > 0) {
            this.autoIndex = 0;
            this.serviceValidationsList = response.resources.validations;
            this.openServiceCallDialog(this.serviceValidationsList[0]);
            // let findDataEsc = response.resources.validations.find(x => x.validateType == ValidateType.ESCALAATION)
            // if (findDataEsc) {
            //   this.openServiceCallDialog(findDataEsc)
            // } else {
            //   response.resources.validations.forEach(element => {
            //     this.openServiceCallDialog(element)
            //   });
            // }
            // let findDataWar = response.resources.validations.find(x => x.validateType == ValidateType.INWARRANTY)
            // if (findDataWar) {
            //   this.openServiceCallDialog(findDataWar)
            // }
          }
        }
      })
  }

  // special project call
  checkValidateSpecialProject() {
    this.rxjsService.setGlobalLoaderProperty(true);
    this.crudService.get(ModulesBasedApiSuffix.TECHNICIAN, TechnicalMgntModuleApiSuffixModels.SPECIAL_PROEJCT_VALIDATION, undefined,
      false, prepareGetRequestHttpParams(null, null, {
        CustomerId: this.customerId, AddressId: this.customerAddressId
      })).subscribe(response => {
        this.loading = false;
        this.rxjsService.setGlobalLoaderProperty(false);
        this.isDealerCall = response.resources.isDealerCall
        if (response.resources.isSuccess) {
          this.navigateToInstallationBySpecialProject()
        } else {
          if (response.resources.validations.length > 0) {
            this.autoIndexSpecialProject = 0
            this.specilProjectValidationsList = response.resources.validations
            this.openSpecialProjectDialog(this.specilProjectValidationsList[0])
          }
        }
      })
  }

  // check validate inspection call
  checkValidateInspectionCall() {
    this.rxjsService.setGlobalLoaderProperty(true);
    this.crudService.get(ModulesBasedApiSuffix.TECHNICIAN, TechnicalMgntModuleApiSuffixModels.INSPECTION_VALIDATION, undefined, false, prepareGetRequestHttpParams(null, null,
      {
        CustomerId: this.customerId, AddressId: this.customerAddressId
      })).subscribe((response: IApplicationResponse) => {
        this.rxjsService.setGlobalLoaderProperty(false);
        this.isDealerCall = response.resources.isDealerCall
        if (response.isSuccess == true && response.statusCode == 200) {
          if (response.resources.isSuccess && response?.resources?.validateType?.toLowerCase() == 'escalation') {
            const alertDialog = this.dialog.open(InspectionCallEscalationDialogComponent, {
              width: '500px',
              data: {
                header: 'Alert',
                message: response.resources.validateMessage,
                buttons: {
                  cancel: 'No',
                  create: 'Yes'
                },
                type: 'alert'
              },
              disableClose: true
            });
            alertDialog.afterClosed().subscribe(result => {
              if (result) {
                // second pop up starts
                const appointmentDialog = this.dialog.open(InspectionCallEscalationDialogComponent, {
                  width: '500px',
                  data: {
                    header: 'Inspection Call Escalation',
                    type: 'appointment',
                    createdUserId: this.userData.userId,
                    CustomerInspectionId: response.resources.customerInspectionId
                  },
                  disableClose: true
                });
                appointmentDialog.afterClosed().subscribe(result => {
                  if (!result) return;
                  this.rxjsService.setDialogOpenProperty(false);
                });
                // second pop up ends
              } else {
                const appointmentDialog = this.dialog.open(InspectionCallEscalationDialogComponent, {
                  width: '500px',
                  data: {
                    header: 'Create a new inspection call',
                    type: 'anotherinspection',
                    // createdUserId: this.userData.userId,
                    // CustomerInspectionId: response.resources.customerInspectionId
                    pendingInspectionCalls: response.resources.pendingInspectionCalls.length > 0 ? response.resources.pendingInspectionCalls : []
                  },
                  disableClose: true
                });
                appointmentDialog.afterClosed().subscribe(result => {
                  if (!result) return;
                  if (this.technicallDetail?.isDealerCall) {
                    this.router.navigate(['/customer/manage-customers/inspection-call'], { queryParams: { referenceId: result, customerId: this.customerId, isDealer: true, isNew: 'customerlist' } });
                  } else {
                    this.router.navigate(['/customer/manage-customers/inspection-call'], { queryParams: { referenceId: result, customerId: this.customerId, isNew: 'customerlist' } });
                  }
                });
              }
              this.rxjsService.setDialogOpenProperty(false);
            });
          } else if (response?.resources?.validateType?.toLowerCase() == 'status') {
            this.onConfirmDialog(response.resources.validateMessage);
          } else {
            const appointmentDialog = this.dialog.open(InspectionCallEscalationDialogComponent, {
              width: '500px',
              data: {
                header: 'Create a new inspection call',
                type: 'anotherinspection',
                pendingInspectionCalls: response.resources.pendingInspectionCalls.length > 0 ? response.resources.pendingInspectionCalls : []
              },
              disableClose: true
            });
            appointmentDialog.afterClosed().subscribe(result => {
              if (!result) return;
              this.router.navigate(['/customer/manage-customers/inspection-call'], { queryParams: { referenceId: result, customerId: this.customerId, isNew: 'customerlist' } });
            });
          }
        }
      });
  }

  //radio removals
  checkValidateRadioRemovals() {
    this.rxjsService.setGlobalLoaderProperty(true);
    this.crudService.get(ModulesBasedApiSuffix.TECHNICIAN, TechnicalMgntModuleApiSuffixModels.RADIO_REMOVAL_CALL_VALIDATION,
      undefined,
      false, prepareRequiredHttpParams({
        CustomerId: this.customerId, AddressId: this.customerAddressId, radioRemovalWorkListId: this.radioRemovalWorkListId,
      }))
      .subscribe(response => {
        this.loading = false;
        this.rxjsService.setGlobalLoaderProperty(false);
        if (response.resources?.isSuccess) {
          this.rxjsService.setViewCallInitiationData({
            customerId: this.customerId,
            customerAddressId: this.customerAddressId,
            partitionId: this.partitionId,
            radioRemovalWorkListId: this.radioRemovalWorkListId,
            initiationId: "",
            appointmentId: this.appointmentId ? this.appointmentId : null,
            callType: 2,
          })
          this.rxjsService.navigateToCallInitiationPage('/customer/manage-customers/radio-removal-call');
        } else {
          if (response.resources.validations.length > 0 &&
            response.resources.validations[0]?.validateType?.toLowerCase() != 'escalation') {
            this.onConfirmDialog(response.resources.validations[0]?.validateMessage);
          } else if (response.resources.validations.length > 0 && response.resources.validations[0]?.validateType?.toLowerCase() == 'escalation') {
            this.serviceValidationsList = response.resources.validations[0].validateData;
            const ref = this.dialogService.open(RadioCallEscalationDialogComponent, {
              showHeader: false,
              header: "Radio Removal Call " + response.resources.validations[0]?.validateType,
              baseZIndex: 10000,
              width: '550px',
              data: response.resources.validations[0],
            });
            ref.onClose.subscribe((result) => {
              if (result && result?.validateType?.toLowerCase() == 'escalation') {
                this.openRadioCallEscalationDialog(result);
              }
            })
          }
        }
      })
  }

  onConfirmDialog(message) {
    const dialogData = new ConfirmDialogModel("Alert", message);
    const dialogRef = this.dialog.open(ConfirmDialogPopupComponent, {
      width: "40vw",
      data: { ...dialogData, isConfirm: false, isAlert: true, msgCenter: true, isClose: true },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }
      return;
    });
  }

  checkAllValidationCalls(callType: CallType | any) {
    let isAccessDeined = this.getPermissionByActionType(callType);
    if (isAccessDeined) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR);
    }
    if (CallType.SERVICE_CALL == callType) {
      this.checkValidateServiceCall();
    } else if (CallType.INSPECTION == callType) {
      this.checkValidateInspectionCall();
    } else if (CallType.SPECIALPROJECT_CALL == callType) {
      this.checkValidateSpecialProject();
    } else if (CallType.RADIO_REMOVAL == callType) {
      this.checkValidateRadioRemovals();
    }
  }

  openCreditControlNotificationDialog(data) {
    const ref = this.dialogService.open(CreditControlNotificationDialogComponent, {
      showHeader: false,
      header: 'Notification',
      baseZIndex: 10000,
      width: '550px',
      data: data,
    });
    ref.onClose.subscribe((result) => {
      // if (result) {
      this.checkAllValidationCalls(data?.callType)
      // }
    });
  }

  openServiceCallDialog(rowData) {
    rowData['isDealerCall'] = this.isDealerCall
    const ref = this.dialogService.open(ServiceCallWaringDialogComponent, {
      showHeader: false,
      header: "Service Call " + rowData.validateType,
      baseZIndex: 10000,
      width: '550px',
      data: rowData,
    });
    ref.onClose.subscribe((result) => {
      if (result) {
        if (result == 1) {
          this.openServiceCallEscalationDialog(rowData)
        } else if (result == 2) {
          if (this.autoIndex < (this.serviceValidationsList.length - 1)) {
            this.autoIndex++;
            this.openServiceCallDialog(this.serviceValidationsList[this.autoIndex])
          } else {
            this.navigateToInstallationByServiceCall()
          }
        } else if (result == 3) {
          this.openInwarrantyEscalationDialog(rowData)
        } else if (result == 4) { // view termination
          this.navigateToSubscriptionTab();
        }
      } else {
        if (this.autoIndex < (this.serviceValidationsList.length - 1)) {
          this.autoIndex++;
          this.openServiceCallDialog(this.serviceValidationsList[this.autoIndex])
        }
      }
    });
  }

  navigateToSubscriptionTab() {
    // Get the current query parameters to preserve fromComponent
    const currentQueryParams = this.activatedRoute.snapshot.queryParams;
    
    this.rxjsService.setViewCustomerData({
      customerId: this.customerId,
      addressId: this.customerAddressId,
      partitionId: this.partitionId,
      customerTab: 6,
      monitoringTab: 0,
      fromComponent: currentQueryParams['fromComponent'] // Preserve the fromComponent parameter
    });
    this.rxjsService.navigateToViewCustomerPage();
  }

  openInwarrantyEscalationDialog(rowData) {
    const ref1 = this.dialogService.open(ServiceCallInwarrantyDialogComponent, {
      showHeader: true,
      header: "Service Call " + rowData.validateType,
      baseZIndex: 1000,
      width: '550px',
      data: {
        ...rowData,
        createdUserId: this.userData?.userId,
      },
    });
    ref1.onClose.subscribe((result) => {
      this.dialogRef.close()
      if (result) {
        setTimeout(() => {
          // Get the current query parameters to preserve fromComponent
          const currentQueryParams = this.activatedRoute.snapshot.queryParams;
          
          if (this.isDealerCall) {
            var routerUrl = '/customer/manage-customers/dealer-call'
          } else {
            var routerUrl = '/customer/manage-customers/call-initiation'
          }
          let queryParamsObj = {
            customerId: this.customerId,
            customerAddressId: this.customerAddressId,
            partitionId: this.partitionId,
            technicianName: rowData?.technicianName,
            fromComponent: currentQueryParams['fromComponent'] // Preserve the fromComponent parameter
          }
          if (rowData.validateType == ValidateType.INWARRANTY) {
            queryParamsObj['warrantyRecallReferenceId'] = result?.id;
          }
          if (rowData.validateType == ValidateType.ESCALAATION) {
            queryParamsObj['initiationId'] = result?.id;
            queryParamsObj['escalationPopup'] = true;
          }
          if (this.appointmentId) {
            queryParamsObj['appointmentId'] = this.appointmentId;
          }
          queryParamsObj['callType'] = 2;// 2- service call, 1- installation call
          this.rxjsService.setViewCallInitiationData(queryParamsObj)
          this.rxjsService.navigateToCallInitiationPage(routerUrl);
        }, 100);
      }
    });
  }

  openServiceCallEscalationDialog(rowData) {
    const objName = CUSTOMER_COMPONENT.SERVICE;
    const escalationEditPermission = this.rolePermission?.find(el => el?.[objName])?.[objName]?.find(el => el?.menuName == PermissionTypes.QUICK_ACTION)?.subMenu?.find(el => el?.menuName == CUSTOMER_COMPONENT.ESCALAATION)?.subMenu?.find(el => el?.menuName == PermissionTypes.EDIT);
    const ref = this.dialogService.open(CallEscalationDialogComponent, {
      width: '550px',
      header: "Service Call " + rowData.validateType,
      data: {
        ...rowData,
        createdUserId: this.userData?.userId,
        editPermission: escalationEditPermission,
      },
      showHeader: false,
    });
    ref.onClose.subscribe((result) => {
      this.dialogRef.close()
      if (result) {
        // Get the current query parameters to preserve fromComponent
        const currentQueryParams = this.activatedRoute.snapshot.queryParams;
        
        if (this.isDealerCall) {
          var routerUrl = '/customer/manage-customers/dealer-call'
        } else {
          var routerUrl = '/customer/manage-customers/call-initiation'
        }
        this.rxjsService.setViewCallInitiationData({
          customerId: this.customerId,
          customerAddressId: this.customerAddressId,
          partitionId: this.partitionId,
          appointmentId: this.appointmentId ? this.appointmentId : null,
          warrantyRecallReferenceId: (rowData.validateType == ValidateType.INWARRANTY) ? result : null,
          initiationId: (rowData.validateType == ValidateType.ESCALAATION) ? result : null,
          callType: 2, // 2- service call, 1- installation call
          callInitiationStatus: rowData?.callInitiationStatus,
          technicianName: rowData?.technicianName,
          escalationPopup: (rowData.validateType == ValidateType.ESCALAATION) ? true : false,
          fromComponent: currentQueryParams['fromComponent'] // Preserve the fromComponent parameter
        })
        this.rxjsService.navigateToCallInitiationPage(routerUrl);
      }
    });
  }

  openRadioCallEscalationDialog(rowData) {
    const ref1 = this.dialogService.open(RadioCallEscalationDialogComponent, {
      showHeader: false,
      header: "Radio Removal Call " + rowData.validateType,
      baseZIndex: 1000,
      width: '550px',
      data: {
        ...rowData,
        createdUserId: this.userData?.userId,
        radioRemovalWorkListId: this.radioRemovalWorkListId,
        isRadioEscalation: true,
      },
    });
    ref1.onClose.subscribe((result) => {
      this.dialogRef.close();
      if (result) {
      }
    });
  }

  openSpecialProjectDialog(rowData) {
    rowData['isDealerCall'] = this.isDealerCall
    const ref = this.dialogService.open(SpecialProjectWaringDialogComponent, {
      showHeader: false,
      header: rowData.validateType ? rowData.validateType : "Special Project",
      baseZIndex: 10000,
      width: '550px',
      data: rowData,
    });
    ref.onClose.subscribe((result) => {
      if (result) {
        if (result == 2) {
          if (this.autoIndexSpecialProject < (this.specilProjectValidationsList.length - 1)) {
            this.autoIndexSpecialProject++;
            this.openSpecialProjectDialog(this.specilProjectValidationsList[this.autoIndexSpecialProject])
          } else {
            this.navigateToInstallationBySpecialProject()
          }
        } else if (result == 4) { // view termination
          this.navigateToSubscriptionTab();
        }
      } else {
        if (this.autoIndexSpecialProject < (this.specilProjectValidationsList.length - 1)) {
          this.autoIndexSpecialProject++;
          this.openSpecialProjectDialog(this.specilProjectValidationsList[this.autoIndexSpecialProject])
        }
      }
    });
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet((this.selectedRows.length > 0) ? this.selectedRows : this.dataList);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].caption);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }
  getPermissionByActionType(actionTypeMenuName): boolean {
    let foundObj = this.rolePermission?.find(el => el[actionTypeMenuName]);
    if (foundObj) {
      return false;
    }
    else {
      return true;
    }
  }

  ngOnDestroy() {
    if (this.techTableSubscription) {
      this.techTableSubscription?.unsubscribe();
    }
    if (this.techDetailsSubscription) {
      this.techDetailsSubscription?.unsubscribe();
    }
    if (this.techQuerySubscription) {
      this.techQuerySubscription?.unsubscribe();
    }
    if (this.techLoadSubscription) {
      this.techLoadSubscription?.unsubscribe();
    }
  }
}
